export default {
  welcomes: 'Chào mừng bạn đến với phần phụ trợ, vui lòng chọn các thanh menu khác ở bên trái',
  support: 'Hỗ trợ',
  gopaylabel: 'Cung cấp dịch vụ thanh toán điện tử nhanh chóng, tiện lợi và an toàn tuyệt đối',
  rules: {
    username: 'tài khoản không được bỏ trống！',
    password: 'mật khẩu không được bỏ trống！',
    code: 'mã xác nhận không được bỏ trống！',
    form: {
      assist: 'hỗ trợ',
      system: 'Hệ thống quản lý khách hàng',
      Login: 'Thông tin đăng nhập',
      UserName: 'Nhập tên đăng nhập',
      Password: 'Nhập mật mã',
      verification: 'Nhập mã xác minh google',
      Forgotpassword: 'Quên mật khẩu?',
      btnlogin: 'Đăng nhập',
      label:
        'Cam kết cung cấp dịch vụ thanh toán điện tử nhanh chóng, tiện lợi và cực kỳ an toàn. Hoạt động 24/7.',
      fast_lable: 'Cung cấp dịch vụ thanh toán điện tử nhanh chóng, tiện lợi và an toàn',
      accountName: 'Tên tài khoản',
      password_fast: 'mật khẩu',
      GoogleCode: 'Mã xác minh của Google'
    }
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/vi/login.js